import moment from "moment";

// Filtros da página guardados por usePersistedFilters('financeiro.contasReceber').
// Só valores serializáveis: mês 'YYYY-MM', período personalizado em 'YYYY-MM-DD'.
export var getDefaultContasReceberFilters = function() {
    return {
        month: moment().format("YYYY-MM"),
        customRange: null,
        view: "all",
        source: "all",
        search: "",
    };
};

var hasCustomRange = function(filters) {
    return !!(filters && filters.customRange && filters.customRange.from && filters.customRange.to);
};

// Transforma o filtro salvo nos parâmetros de /contas-receber: o período
// personalizado, se houver, senão o mês inteiro.
export var getContasReceberPeriodRequest = function(filters) {
    if (hasCustomRange(filters)) {
        return { from: filters.customRange.from, to: filters.customRange.to, status: "all" };
    }
    var m = moment(filters.month, "YYYY-MM");
    return {
        from: m.clone().startOf("month").format("YYYY-MM-DD"),
        to: m.clone().endOf("month").format("YYYY-MM-DD"),
        status: "all",
    };
};

export var isContasReceberPeriodDefault = function(filters, defaults) {
    return !hasCustomRange(filters) && filters.month === defaults.month;
};

// Badge do botão Filtros: só o que difere do padrão.
export var countActiveContasReceberFilters = function(filters, defaults) {
    return (isContasReceberPeriodDefault(filters, defaults) ? 0 : 1) +
        (filters.view !== defaults.view ? 1 : 0) +
        (filters.source !== defaults.source ? 1 : 0) +
        (filters.search ? 1 : 0);
};
